import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatStatsService {
  private visitorsStats = new Map<string, any>();

  private readonly _visitorStatsChange$ = new Subject<string>();
  readonly visitorStatsChange$ = this._visitorStatsChange$.asObservable();

  getStatsMessage(responseId: string): any {
    if (this.visitorsStats.get(responseId)) {
      return this.visitorsStats.get(responseId);
    }
    return {};
  }

  setStatsMessage(responseId: string, stats: any) {
    this.visitorsStats.set(responseId, stats);
    this._visitorStatsChange$.next(responseId);
  }
}
